import { default as abouto1ZLyKDsW1Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue?macro=true";
import { default as eventsT6Sws3W2HnMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_938EUCTszPViMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45sampleM7PYGhgwvFMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsd5vbKRComZMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_934qhLpRkfX4Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewHx5aMJ1uGEMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as index1FzwXvJNg7Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_936HZaZBXMomMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexamn4X9SKHSMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93mvCsP1K32vMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as indexHPTGAZ6Iu4Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsNk587J5PESMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsLxnDipNbRXMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewss8v08qoFmWMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93cq8WbnFTxDMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue?macro=true";
import { default as indexL1yVM1uOuQMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/buy/product/[product_id]/index.vue?macro=true";
import { default as confirmGAD5po8IVBMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue?macro=true";
import { default as confirmIIIQ6WGiemMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue?macro=true";
import { default as calendardfB6sSSiOmMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/calendar.vue?macro=true";
import { default as chatCwzM6HcoeoMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/chat.vue?macro=true";
import { default as aboutshZH1gjeYZMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/community-groups/[group_id]/about.vue?macro=true";
import { default as feedMpEtnnPMPbMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/community-groups/[group_id]/feed.vue?macro=true";
import { default as memberse5QFjjHvRCMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/community-groups/[group_id]/members.vue?macro=true";
import { default as _91group_id_93VmmnrRFDOFMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/community-groups/[group_id].vue?macro=true";
import { default as community_45profile_45editQwPbyyjI4zMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/community-profile-edit.vue?macro=true";
import { default as _91id_93fOCxX638XMMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/community-profile/[id].vue?macro=true";
import { default as communitypQmfztF0MtMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/community.vue?macro=true";
import { default as _91uuid_93cKOU8mMSMVMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/complete-registration/[uuid].vue?macro=true";
import { default as _91unique_id_93HSvZPC83uLMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/contracts/[unique_id].vue?macro=true";
import { default as dashboardZGBtGoRUiQMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/dashboard.vue?macro=true";
import { default as indexvMHs2h3oe6Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/event/details/[event_id]/index.vue?macro=true";
import { default as checkoutupWXlNEa6bMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue?macro=true";
import { default as select_45productN9rA4aOSVrMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/event/details/[event_id]/select-product.vue?macro=true";
import { default as eventsAVyGI4haOBMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/events.vue?macro=true";
import { default as _91uuid_93w8z5YXjHJ2Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/gifts/[uuid].vue?macro=true";
import { default as indexoFMnrskjThMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/gifts/index.vue?macro=true";
import { default as _91invitation_id_93WlrOEzrN6nMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/gifts/invitation/[invitation_id].vue?macro=true";
import { default as _91product_id_93Pv1DSHj3UnMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/gifts/product/[product_id].vue?macro=true";
import { default as indexhz2w8JrTpAMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/index.vue?macro=true";
import { default as _91invitation_unique_id_93HQPyMKCYusMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/invitation/[invitation_unique_id].vue?macro=true";
import { default as joinaqIrfp9AAzMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/join.vue?macro=true";
import { default as loginJrOzEy3NIlMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/login.vue?macro=true";
import { default as logoutpcdDzZHVlgMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/logout.vue?macro=true";
import { default as _91meeting_type_slug_93rFSNWWtr3VMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/meet/[meeting_type_slug].vue?macro=true";
import { default as _91meeting_unique_id_93ozO1dloAdqMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/meet/[meeting_unique_id].vue?macro=true";
import { default as _91meeting_unique_id_93tdiqBr4ldxMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/meeting/[meeting_unique_id].vue?macro=true";
import { default as my_45favorites8j5KmSLoV8Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/my-favorites.vue?macro=true";
import { default as my_45studiosJ2WKpoKN9zMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/my-studios.vue?macro=true";
import { default as optinDpGNwXwXOCMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/optin.vue?macro=true";
import { default as _91episode_id_93tgIcqIYQr0Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue?macro=true";
import { default as indexefxnCqmbb0Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/podcasts/[podcast_id]/index.vue?macro=true";
import { default as index7X4dA5pcQNMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/podcasts/index.vue?macro=true";
import { default as aboutpD6gXt9pWDMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/about.vue?macro=true";
import { default as digital_45download_45contentuARi74LE1LMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/digital-download-content.vue?macro=true";
import { default as eventsUfHdKy6xw1Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/events.vue?macro=true";
import { default as _91media_id_93zYG5PV3WVvMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue?macro=true";
import { default as free_45samplexo2hT8i9bUMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/free-sample.vue?macro=true";
import { default as included_45productsB35TqqdTFVMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/included-products.vue?macro=true";
import { default as _91media_id_93J27PQdW7m7Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue?macro=true";
import { default as viewE8PLyq3AfeMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue?macro=true";
import { default as indexR3MmoE8GKZMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/lessons/index.vue?macro=true";
import { default as _91media_id_93KBAPmmyNtoMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/media/[media_id].vue?macro=true";
import { default as indexQIazUKy61LMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue?macro=true";
import { default as _91media_id_93XFcnhviNayMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue?macro=true";
import { default as index9SRThuGdiQMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/playlists/index.vue?macro=true";
import { default as private_45sessionsXd4Sl9kRbyMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/private-sessions.vue?macro=true";
import { default as recordingsfBHopyYbwNMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/recordings.vue?macro=true";
import { default as reviewshxNqWRicWfMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/reviews.vue?macro=true";
import { default as _91product_id_93zECX858UOOMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id].vue?macro=true";
import { default as indexS2VT6iy50GMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/product/index.vue?macro=true";
import { default as indexCiIBHqqGjzMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/profile/index.vue?macro=true";
import { default as purchasesB8JeKMyEM4Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/profile/purchases.vue?macro=true";
import { default as redemptionsjor0whaZuhMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/profile/redemptions.vue?macro=true";
import { default as _91quiz_id_93atPSbOHxTcMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/quiz/[quiz_id].vue?macro=true";
import { default as _91token_9374AFZRgegRMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/reset-password/[uid]/[token].vue?macro=true";
import { default as resetwKvTAkeYdMMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/reset.vue?macro=true";
import { default as shoppc6rfpmaGQMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/shop.vue?macro=true";
import { default as signupYCBANXFaaoMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/signup.vue?macro=true";
import { default as liveKglRQ9npWvMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/streaming/[event_id]/live.vue?macro=true";
import { default as tipspsVh9hWTq8Meta } from "/tmp/build_ea8f28b6/pages/[studio_url]/tips.vue?macro=true";
import { default as _91uuid_93HFtK4Y68IlMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/waiver/[uuid].vue?macro=true";
import { default as compactqKJeTKgjcJMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/widgets/calendars/compact.vue?macro=true";
import { default as fullWUcRRdDI0QMeta } from "/tmp/build_ea8f28b6/pages/[studio_url]/widgets/calendars/full.vue?macro=true";
export default [
  {
    name: _91product_id_93cq8WbnFTxDMeta?.name ?? "bundle-bundle_id-product-product_id",
    path: _91product_id_93cq8WbnFTxDMeta?.path ?? "/bundle/:bundle_id()/product/:product_id()",
    meta: _91product_id_93cq8WbnFTxDMeta || {},
    alias: _91product_id_93cq8WbnFTxDMeta?.alias || [],
    redirect: _91product_id_93cq8WbnFTxDMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: abouto1ZLyKDsW1Meta?.name ?? "bundle-bundle_id-product-product_id-about",
    path: abouto1ZLyKDsW1Meta?.path ?? "about",
    meta: abouto1ZLyKDsW1Meta || {},
    alias: abouto1ZLyKDsW1Meta?.alias || [],
    redirect: abouto1ZLyKDsW1Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: eventsT6Sws3W2HnMeta?.name ?? "bundle-bundle_id-product-product_id-events",
    path: eventsT6Sws3W2HnMeta?.path ?? "events",
    meta: eventsT6Sws3W2HnMeta || {},
    alias: eventsT6Sws3W2HnMeta?.alias || [],
    redirect: eventsT6Sws3W2HnMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_938EUCTszPViMeta?.name ?? "bundle-bundle_id-product-product_id-free-media-media_id",
    path: _91media_id_938EUCTszPViMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_938EUCTszPViMeta || {},
    alias: _91media_id_938EUCTszPViMeta?.alias || [],
    redirect: _91media_id_938EUCTszPViMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45sampleM7PYGhgwvFMeta?.name ?? "bundle-bundle_id-product-product_id-free-sample",
    path: free_45sampleM7PYGhgwvFMeta?.path ?? "free-sample",
    meta: free_45sampleM7PYGhgwvFMeta || {},
    alias: free_45sampleM7PYGhgwvFMeta?.alias || [],
    redirect: free_45sampleM7PYGhgwvFMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsd5vbKRComZMeta?.name ?? "bundle-bundle_id-product-product_id-included-products",
    path: included_45productsd5vbKRComZMeta?.path ?? "included-products",
    meta: included_45productsd5vbKRComZMeta || {},
    alias: included_45productsd5vbKRComZMeta?.alias || [],
    redirect: included_45productsd5vbKRComZMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_934qhLpRkfX4Meta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_934qhLpRkfX4Meta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_934qhLpRkfX4Meta || {},
    alias: _91media_id_934qhLpRkfX4Meta?.alias || [],
    redirect: _91media_id_934qhLpRkfX4Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewHx5aMJ1uGEMeta?.name ?? "bundle-bundle_id-product-product_id-lessons-lesson_id-view",
    path: viewHx5aMJ1uGEMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewHx5aMJ1uGEMeta || {},
    alias: viewHx5aMJ1uGEMeta?.alias || [],
    redirect: viewHx5aMJ1uGEMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: index1FzwXvJNg7Meta?.name ?? "bundle-bundle_id-product-product_id-lessons",
    path: index1FzwXvJNg7Meta?.path ?? "lessons",
    meta: index1FzwXvJNg7Meta || {},
    alias: index1FzwXvJNg7Meta?.alias || [],
    redirect: index1FzwXvJNg7Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_936HZaZBXMomMeta?.name ?? "bundle-bundle_id-product-product_id-media-media_id",
    path: _91media_id_936HZaZBXMomMeta?.path ?? "media/:media_id()",
    meta: _91media_id_936HZaZBXMomMeta || {},
    alias: _91media_id_936HZaZBXMomMeta?.alias || [],
    redirect: _91media_id_936HZaZBXMomMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexamn4X9SKHSMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id",
    path: indexamn4X9SKHSMeta?.path ?? "playlists/:playlist_id()",
    meta: indexamn4X9SKHSMeta || {},
    alias: indexamn4X9SKHSMeta?.alias || [],
    redirect: indexamn4X9SKHSMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93mvCsP1K32vMeta?.name ?? "bundle-bundle_id-product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93mvCsP1K32vMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93mvCsP1K32vMeta || {},
    alias: _91media_id_93mvCsP1K32vMeta?.alias || [],
    redirect: _91media_id_93mvCsP1K32vMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexHPTGAZ6Iu4Meta?.name ?? "bundle-bundle_id-product-product_id-playlists",
    path: indexHPTGAZ6Iu4Meta?.path ?? "playlists",
    meta: indexHPTGAZ6Iu4Meta || {},
    alias: indexHPTGAZ6Iu4Meta?.alias || [],
    redirect: indexHPTGAZ6Iu4Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsNk587J5PESMeta?.name ?? "bundle-bundle_id-product-product_id-private-sessions",
    path: private_45sessionsNk587J5PESMeta?.path ?? "private-sessions",
    meta: private_45sessionsNk587J5PESMeta || {},
    alias: private_45sessionsNk587J5PESMeta?.alias || [],
    redirect: private_45sessionsNk587J5PESMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsLxnDipNbRXMeta?.name ?? "bundle-bundle_id-product-product_id-recordings",
    path: recordingsLxnDipNbRXMeta?.path ?? "recordings",
    meta: recordingsLxnDipNbRXMeta || {},
    alias: recordingsLxnDipNbRXMeta?.alias || [],
    redirect: recordingsLxnDipNbRXMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewss8v08qoFmWMeta?.name ?? "bundle-bundle_id-product-product_id-reviews",
    path: reviewss8v08qoFmWMeta?.path ?? "reviews",
    meta: reviewss8v08qoFmWMeta || {},
    alias: reviewss8v08qoFmWMeta?.alias || [],
    redirect: reviewss8v08qoFmWMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/bundle/[bundle_id]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexL1yVM1uOuQMeta?.name ?? "buy-product-product_id",
    path: indexL1yVM1uOuQMeta?.path ?? "/buy/product/:product_id()",
    meta: indexL1yVM1uOuQMeta || {},
    alias: indexL1yVM1uOuQMeta?.alias || [],
    redirect: indexL1yVM1uOuQMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/buy/product/[product_id]/index.vue").then(m => m.default || m)
  },
  {
    name: confirmGAD5po8IVBMeta?.name ?? "buy-product-product_id-paypal-confirm",
    path: confirmGAD5po8IVBMeta?.path ?? "/buy/product/:product_id()/paypal/confirm",
    meta: confirmGAD5po8IVBMeta || {},
    alias: confirmGAD5po8IVBMeta?.alias || [],
    redirect: confirmGAD5po8IVBMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/buy/product/[product_id]/paypal/confirm.vue").then(m => m.default || m)
  },
  {
    name: confirmIIIQ6WGiemMeta?.name ?? "buy-product-product_id-stripe-confirm",
    path: confirmIIIQ6WGiemMeta?.path ?? "/buy/product/:product_id()/stripe/confirm",
    meta: confirmIIIQ6WGiemMeta || {},
    alias: confirmIIIQ6WGiemMeta?.alias || [],
    redirect: confirmIIIQ6WGiemMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/buy/product/[product_id]/stripe/confirm.vue").then(m => m.default || m)
  },
  {
    name: calendardfB6sSSiOmMeta?.name ?? "calendar",
    path: calendardfB6sSSiOmMeta?.path ?? "/calendar",
    meta: calendardfB6sSSiOmMeta || {},
    alias: calendardfB6sSSiOmMeta?.alias || [],
    redirect: calendardfB6sSSiOmMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/calendar.vue").then(m => m.default || m)
  },
  {
    name: chatCwzM6HcoeoMeta?.name ?? "chat",
    path: chatCwzM6HcoeoMeta?.path ?? "/chat",
    meta: chatCwzM6HcoeoMeta || {},
    alias: chatCwzM6HcoeoMeta?.alias || [],
    redirect: chatCwzM6HcoeoMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/chat.vue").then(m => m.default || m)
  },
  {
    name: _91group_id_93VmmnrRFDOFMeta?.name ?? "community-groups-group_id",
    path: _91group_id_93VmmnrRFDOFMeta?.path ?? "/community-groups/:group_id()",
    meta: _91group_id_93VmmnrRFDOFMeta || {},
    alias: _91group_id_93VmmnrRFDOFMeta?.alias || [],
    redirect: _91group_id_93VmmnrRFDOFMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/community-groups/[group_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutshZH1gjeYZMeta?.name ?? "community-groups-group_id-about",
    path: aboutshZH1gjeYZMeta?.path ?? "about",
    meta: aboutshZH1gjeYZMeta || {},
    alias: aboutshZH1gjeYZMeta?.alias || [],
    redirect: aboutshZH1gjeYZMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/community-groups/[group_id]/about.vue").then(m => m.default || m)
  },
  {
    name: feedMpEtnnPMPbMeta?.name ?? "community-groups-group_id-feed",
    path: feedMpEtnnPMPbMeta?.path ?? "feed",
    meta: feedMpEtnnPMPbMeta || {},
    alias: feedMpEtnnPMPbMeta?.alias || [],
    redirect: feedMpEtnnPMPbMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/community-groups/[group_id]/feed.vue").then(m => m.default || m)
  },
  {
    name: memberse5QFjjHvRCMeta?.name ?? "community-groups-group_id-members",
    path: memberse5QFjjHvRCMeta?.path ?? "members",
    meta: memberse5QFjjHvRCMeta || {},
    alias: memberse5QFjjHvRCMeta?.alias || [],
    redirect: memberse5QFjjHvRCMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/community-groups/[group_id]/members.vue").then(m => m.default || m)
  }
]
  },
  {
    name: community_45profile_45editQwPbyyjI4zMeta?.name ?? "community-profile-edit",
    path: community_45profile_45editQwPbyyjI4zMeta?.path ?? "/community-profile-edit",
    meta: community_45profile_45editQwPbyyjI4zMeta || {},
    alias: community_45profile_45editQwPbyyjI4zMeta?.alias || [],
    redirect: community_45profile_45editQwPbyyjI4zMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/community-profile-edit.vue").then(m => m.default || m)
  },
  {
    name: _91id_93fOCxX638XMMeta?.name ?? "community-profile-id",
    path: _91id_93fOCxX638XMMeta?.path ?? "/community-profile/:id()",
    meta: _91id_93fOCxX638XMMeta || {},
    alias: _91id_93fOCxX638XMMeta?.alias || [],
    redirect: _91id_93fOCxX638XMMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/community-profile/[id].vue").then(m => m.default || m)
  },
  {
    name: communitypQmfztF0MtMeta?.name ?? "community",
    path: communitypQmfztF0MtMeta?.path ?? "/community",
    meta: communitypQmfztF0MtMeta || {},
    alias: communitypQmfztF0MtMeta?.alias || [],
    redirect: communitypQmfztF0MtMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/community.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93cKOU8mMSMVMeta?.name ?? "complete-registration-uuid",
    path: _91uuid_93cKOU8mMSMVMeta?.path ?? "/complete-registration/:uuid()",
    meta: _91uuid_93cKOU8mMSMVMeta || {},
    alias: _91uuid_93cKOU8mMSMVMeta?.alias || [],
    redirect: _91uuid_93cKOU8mMSMVMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/complete-registration/[uuid].vue").then(m => m.default || m)
  },
  {
    name: _91unique_id_93HSvZPC83uLMeta?.name ?? "contracts-unique_id",
    path: _91unique_id_93HSvZPC83uLMeta?.path ?? "/contracts/:unique_id()",
    meta: _91unique_id_93HSvZPC83uLMeta || {},
    alias: _91unique_id_93HSvZPC83uLMeta?.alias || [],
    redirect: _91unique_id_93HSvZPC83uLMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/contracts/[unique_id].vue").then(m => m.default || m)
  },
  {
    name: dashboardZGBtGoRUiQMeta?.name ?? "dashboard",
    path: dashboardZGBtGoRUiQMeta?.path ?? "/dashboard",
    meta: dashboardZGBtGoRUiQMeta || {},
    alias: dashboardZGBtGoRUiQMeta?.alias || [],
    redirect: dashboardZGBtGoRUiQMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/dashboard.vue").then(m => m.default || m)
  },
  {
    name: indexvMHs2h3oe6Meta?.name ?? "event-details-event_id",
    path: indexvMHs2h3oe6Meta?.path ?? "/event/details/:event_id()",
    meta: indexvMHs2h3oe6Meta || {},
    alias: indexvMHs2h3oe6Meta?.alias || [],
    redirect: indexvMHs2h3oe6Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/event/details/[event_id]/index.vue").then(m => m.default || m)
  },
  {
    name: checkoutupWXlNEa6bMeta?.name ?? "event-details-event_id-product-product_id-checkout",
    path: checkoutupWXlNEa6bMeta?.path ?? "/event/details/:event_id()/product/:product_id()/checkout",
    meta: checkoutupWXlNEa6bMeta || {},
    alias: checkoutupWXlNEa6bMeta?.alias || [],
    redirect: checkoutupWXlNEa6bMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/event/details/[event_id]/product/[product_id]/checkout.vue").then(m => m.default || m)
  },
  {
    name: select_45productN9rA4aOSVrMeta?.name ?? "event-details-event_id-select-product",
    path: select_45productN9rA4aOSVrMeta?.path ?? "/event/details/:event_id()/select-product",
    meta: select_45productN9rA4aOSVrMeta || {},
    alias: select_45productN9rA4aOSVrMeta?.alias || [],
    redirect: select_45productN9rA4aOSVrMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/event/details/[event_id]/select-product.vue").then(m => m.default || m)
  },
  {
    name: eventsAVyGI4haOBMeta?.name ?? "events",
    path: eventsAVyGI4haOBMeta?.path ?? "/events",
    meta: eventsAVyGI4haOBMeta || {},
    alias: eventsAVyGI4haOBMeta?.alias || [],
    redirect: eventsAVyGI4haOBMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/events.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93w8z5YXjHJ2Meta?.name ?? "gifts-uuid",
    path: _91uuid_93w8z5YXjHJ2Meta?.path ?? "/gifts/:uuid()",
    meta: _91uuid_93w8z5YXjHJ2Meta || {},
    alias: _91uuid_93w8z5YXjHJ2Meta?.alias || [],
    redirect: _91uuid_93w8z5YXjHJ2Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/gifts/[uuid].vue").then(m => m.default || m)
  },
  {
    name: indexoFMnrskjThMeta?.name ?? "gifts",
    path: indexoFMnrskjThMeta?.path ?? "/gifts",
    meta: indexoFMnrskjThMeta || {},
    alias: indexoFMnrskjThMeta?.alias || [],
    redirect: indexoFMnrskjThMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/gifts/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_id_93WlrOEzrN6nMeta?.name ?? "gifts-invitation-invitation_id",
    path: _91invitation_id_93WlrOEzrN6nMeta?.path ?? "/gifts/invitation/:invitation_id()",
    meta: _91invitation_id_93WlrOEzrN6nMeta || {},
    alias: _91invitation_id_93WlrOEzrN6nMeta?.alias || [],
    redirect: _91invitation_id_93WlrOEzrN6nMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/gifts/invitation/[invitation_id].vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93Pv1DSHj3UnMeta?.name ?? "gifts-product-product_id",
    path: _91product_id_93Pv1DSHj3UnMeta?.path ?? "/gifts/product/:product_id()",
    meta: _91product_id_93Pv1DSHj3UnMeta || {},
    alias: _91product_id_93Pv1DSHj3UnMeta?.alias || [],
    redirect: _91product_id_93Pv1DSHj3UnMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/gifts/product/[product_id].vue").then(m => m.default || m)
  },
  {
    name: indexhz2w8JrTpAMeta?.name ?? "index",
    path: indexhz2w8JrTpAMeta?.path ?? "/",
    meta: indexhz2w8JrTpAMeta || {},
    alias: indexhz2w8JrTpAMeta?.alias || [],
    redirect: indexhz2w8JrTpAMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/index.vue").then(m => m.default || m)
  },
  {
    name: _91invitation_unique_id_93HQPyMKCYusMeta?.name ?? "invitation-invitation_unique_id",
    path: _91invitation_unique_id_93HQPyMKCYusMeta?.path ?? "/invitation/:invitation_unique_id()",
    meta: _91invitation_unique_id_93HQPyMKCYusMeta || {},
    alias: _91invitation_unique_id_93HQPyMKCYusMeta?.alias || [],
    redirect: _91invitation_unique_id_93HQPyMKCYusMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/invitation/[invitation_unique_id].vue").then(m => m.default || m)
  },
  {
    name: joinaqIrfp9AAzMeta?.name ?? "join",
    path: joinaqIrfp9AAzMeta?.path ?? "/join",
    meta: joinaqIrfp9AAzMeta || {},
    alias: joinaqIrfp9AAzMeta?.alias || [],
    redirect: joinaqIrfp9AAzMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/join.vue").then(m => m.default || m)
  },
  {
    name: loginJrOzEy3NIlMeta?.name ?? "login",
    path: loginJrOzEy3NIlMeta?.path ?? "/login",
    meta: loginJrOzEy3NIlMeta || {},
    alias: loginJrOzEy3NIlMeta?.alias || [],
    redirect: loginJrOzEy3NIlMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/login.vue").then(m => m.default || m)
  },
  {
    name: logoutpcdDzZHVlgMeta?.name ?? "logout",
    path: logoutpcdDzZHVlgMeta?.path ?? "/logout",
    meta: logoutpcdDzZHVlgMeta || {},
    alias: logoutpcdDzZHVlgMeta?.alias || [],
    redirect: logoutpcdDzZHVlgMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/logout.vue").then(m => m.default || m)
  },
  {
    name: _91meeting_type_slug_93rFSNWWtr3VMeta?.name ?? "meet-meeting_type_slug",
    path: _91meeting_type_slug_93rFSNWWtr3VMeta?.path ?? "/meet/:meeting_type_slug()",
    meta: _91meeting_type_slug_93rFSNWWtr3VMeta || {},
    alias: _91meeting_type_slug_93rFSNWWtr3VMeta?.alias || [],
    redirect: _91meeting_type_slug_93rFSNWWtr3VMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/meet/[meeting_type_slug].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93ozO1dloAdqMeta?.name ?? "meet-meeting_unique_id",
    path: _91meeting_unique_id_93ozO1dloAdqMeta?.path ?? "/meet/:meeting_unique_id()",
    meta: _91meeting_unique_id_93ozO1dloAdqMeta || {},
    alias: _91meeting_unique_id_93ozO1dloAdqMeta?.alias || [],
    redirect: _91meeting_unique_id_93ozO1dloAdqMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/meet/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: _91meeting_unique_id_93tdiqBr4ldxMeta?.name ?? "meeting-meeting_unique_id",
    path: _91meeting_unique_id_93tdiqBr4ldxMeta?.path ?? "/meeting/:meeting_unique_id()",
    meta: _91meeting_unique_id_93tdiqBr4ldxMeta || {},
    alias: _91meeting_unique_id_93tdiqBr4ldxMeta?.alias || [],
    redirect: _91meeting_unique_id_93tdiqBr4ldxMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/meeting/[meeting_unique_id].vue").then(m => m.default || m)
  },
  {
    name: my_45favorites8j5KmSLoV8Meta?.name ?? "my-favorites",
    path: my_45favorites8j5KmSLoV8Meta?.path ?? "/my-favorites",
    meta: my_45favorites8j5KmSLoV8Meta || {},
    alias: my_45favorites8j5KmSLoV8Meta?.alias || [],
    redirect: my_45favorites8j5KmSLoV8Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/my-favorites.vue").then(m => m.default || m)
  },
  {
    name: my_45studiosJ2WKpoKN9zMeta?.name ?? "my-studios",
    path: my_45studiosJ2WKpoKN9zMeta?.path ?? "/my-studios",
    meta: my_45studiosJ2WKpoKN9zMeta || {},
    alias: my_45studiosJ2WKpoKN9zMeta?.alias || [],
    redirect: my_45studiosJ2WKpoKN9zMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/my-studios.vue").then(m => m.default || m)
  },
  {
    name: optinDpGNwXwXOCMeta?.name ?? "optin",
    path: optinDpGNwXwXOCMeta?.path ?? "/optin",
    meta: optinDpGNwXwXOCMeta || {},
    alias: optinDpGNwXwXOCMeta?.alias || [],
    redirect: optinDpGNwXwXOCMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/optin.vue").then(m => m.default || m)
  },
  {
    name: _91episode_id_93tgIcqIYQr0Meta?.name ?? "podcasts-podcast_id-episodes-episode_id",
    path: _91episode_id_93tgIcqIYQr0Meta?.path ?? "/podcasts/:podcast_id()/episodes/:episode_id()",
    meta: _91episode_id_93tgIcqIYQr0Meta || {},
    alias: _91episode_id_93tgIcqIYQr0Meta?.alias || [],
    redirect: _91episode_id_93tgIcqIYQr0Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/podcasts/[podcast_id]/episodes/[episode_id].vue").then(m => m.default || m)
  },
  {
    name: indexefxnCqmbb0Meta?.name ?? "podcasts-podcast_id",
    path: indexefxnCqmbb0Meta?.path ?? "/podcasts/:podcast_id()",
    meta: indexefxnCqmbb0Meta || {},
    alias: indexefxnCqmbb0Meta?.alias || [],
    redirect: indexefxnCqmbb0Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/podcasts/[podcast_id]/index.vue").then(m => m.default || m)
  },
  {
    name: index7X4dA5pcQNMeta?.name ?? "podcasts",
    path: index7X4dA5pcQNMeta?.path ?? "/podcasts",
    meta: index7X4dA5pcQNMeta || {},
    alias: index7X4dA5pcQNMeta?.alias || [],
    redirect: index7X4dA5pcQNMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/podcasts/index.vue").then(m => m.default || m)
  },
  {
    name: _91product_id_93zECX858UOOMeta?.name ?? "product-product_id",
    path: _91product_id_93zECX858UOOMeta?.path ?? "/product/:product_id()",
    meta: _91product_id_93zECX858UOOMeta || {},
    alias: _91product_id_93zECX858UOOMeta?.alias || [],
    redirect: _91product_id_93zECX858UOOMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id].vue").then(m => m.default || m),
    children: [
  {
    name: aboutpD6gXt9pWDMeta?.name ?? "product-product_id-about",
    path: aboutpD6gXt9pWDMeta?.path ?? "about",
    meta: aboutpD6gXt9pWDMeta || {},
    alias: aboutpD6gXt9pWDMeta?.alias || [],
    redirect: aboutpD6gXt9pWDMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/about.vue").then(m => m.default || m)
  },
  {
    name: digital_45download_45contentuARi74LE1LMeta?.name ?? "product-product_id-digital-download-content",
    path: digital_45download_45contentuARi74LE1LMeta?.path ?? "digital-download-content",
    meta: digital_45download_45contentuARi74LE1LMeta || {},
    alias: digital_45download_45contentuARi74LE1LMeta?.alias || [],
    redirect: digital_45download_45contentuARi74LE1LMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/digital-download-content.vue").then(m => m.default || m)
  },
  {
    name: eventsUfHdKy6xw1Meta?.name ?? "product-product_id-events",
    path: eventsUfHdKy6xw1Meta?.path ?? "events",
    meta: eventsUfHdKy6xw1Meta || {},
    alias: eventsUfHdKy6xw1Meta?.alias || [],
    redirect: eventsUfHdKy6xw1Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/events.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93zYG5PV3WVvMeta?.name ?? "product-product_id-free-media-media_id",
    path: _91media_id_93zYG5PV3WVvMeta?.path ?? "free-media/:media_id()",
    meta: _91media_id_93zYG5PV3WVvMeta || {},
    alias: _91media_id_93zYG5PV3WVvMeta?.alias || [],
    redirect: _91media_id_93zYG5PV3WVvMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/free-media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: free_45samplexo2hT8i9bUMeta?.name ?? "product-product_id-free-sample",
    path: free_45samplexo2hT8i9bUMeta?.path ?? "free-sample",
    meta: free_45samplexo2hT8i9bUMeta || {},
    alias: free_45samplexo2hT8i9bUMeta?.alias || [],
    redirect: free_45samplexo2hT8i9bUMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/free-sample.vue").then(m => m.default || m)
  },
  {
    name: included_45productsB35TqqdTFVMeta?.name ?? "product-product_id-included-products",
    path: included_45productsB35TqqdTFVMeta?.path ?? "included-products",
    meta: included_45productsB35TqqdTFVMeta || {},
    alias: included_45productsB35TqqdTFVMeta?.alias || [],
    redirect: included_45productsB35TqqdTFVMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/included-products.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93J27PQdW7m7Meta?.name ?? "product-product_id-lessons-lesson_id-play-media_id",
    path: _91media_id_93J27PQdW7m7Meta?.path ?? "lessons/:lesson_id()/play/:media_id()",
    meta: _91media_id_93J27PQdW7m7Meta || {},
    alias: _91media_id_93J27PQdW7m7Meta?.alias || [],
    redirect: _91media_id_93J27PQdW7m7Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/play/[media_id].vue").then(m => m.default || m)
  },
  {
    name: viewE8PLyq3AfeMeta?.name ?? "product-product_id-lessons-lesson_id-view",
    path: viewE8PLyq3AfeMeta?.path ?? "lessons/:lesson_id()/view",
    meta: viewE8PLyq3AfeMeta || {},
    alias: viewE8PLyq3AfeMeta?.alias || [],
    redirect: viewE8PLyq3AfeMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/lessons/[lesson_id]/view.vue").then(m => m.default || m)
  },
  {
    name: indexR3MmoE8GKZMeta?.name ?? "product-product_id-lessons",
    path: indexR3MmoE8GKZMeta?.path ?? "lessons",
    meta: indexR3MmoE8GKZMeta || {},
    alias: indexR3MmoE8GKZMeta?.alias || [],
    redirect: indexR3MmoE8GKZMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/lessons/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93KBAPmmyNtoMeta?.name ?? "product-product_id-media-media_id",
    path: _91media_id_93KBAPmmyNtoMeta?.path ?? "media/:media_id()",
    meta: _91media_id_93KBAPmmyNtoMeta || {},
    alias: _91media_id_93KBAPmmyNtoMeta?.alias || [],
    redirect: _91media_id_93KBAPmmyNtoMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: indexQIazUKy61LMeta?.name ?? "product-product_id-playlists-playlist_id",
    path: indexQIazUKy61LMeta?.path ?? "playlists/:playlist_id()",
    meta: indexQIazUKy61LMeta || {},
    alias: indexQIazUKy61LMeta?.alias || [],
    redirect: indexQIazUKy61LMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91media_id_93XFcnhviNayMeta?.name ?? "product-product_id-playlists-playlist_id-media-media_id",
    path: _91media_id_93XFcnhviNayMeta?.path ?? "playlists/:playlist_id()/media/:media_id()",
    meta: _91media_id_93XFcnhviNayMeta || {},
    alias: _91media_id_93XFcnhviNayMeta?.alias || [],
    redirect: _91media_id_93XFcnhviNayMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/playlists/[playlist_id]/media/[media_id].vue").then(m => m.default || m)
  },
  {
    name: index9SRThuGdiQMeta?.name ?? "product-product_id-playlists",
    path: index9SRThuGdiQMeta?.path ?? "playlists",
    meta: index9SRThuGdiQMeta || {},
    alias: index9SRThuGdiQMeta?.alias || [],
    redirect: index9SRThuGdiQMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/playlists/index.vue").then(m => m.default || m)
  },
  {
    name: private_45sessionsXd4Sl9kRbyMeta?.name ?? "product-product_id-private-sessions",
    path: private_45sessionsXd4Sl9kRbyMeta?.path ?? "private-sessions",
    meta: private_45sessionsXd4Sl9kRbyMeta || {},
    alias: private_45sessionsXd4Sl9kRbyMeta?.alias || [],
    redirect: private_45sessionsXd4Sl9kRbyMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/private-sessions.vue").then(m => m.default || m)
  },
  {
    name: recordingsfBHopyYbwNMeta?.name ?? "product-product_id-recordings",
    path: recordingsfBHopyYbwNMeta?.path ?? "recordings",
    meta: recordingsfBHopyYbwNMeta || {},
    alias: recordingsfBHopyYbwNMeta?.alias || [],
    redirect: recordingsfBHopyYbwNMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/recordings.vue").then(m => m.default || m)
  },
  {
    name: reviewshxNqWRicWfMeta?.name ?? "product-product_id-reviews",
    path: reviewshxNqWRicWfMeta?.path ?? "reviews",
    meta: reviewshxNqWRicWfMeta || {},
    alias: reviewshxNqWRicWfMeta?.alias || [],
    redirect: reviewshxNqWRicWfMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/[product_id]/reviews.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexS2VT6iy50GMeta?.name ?? "product",
    path: indexS2VT6iy50GMeta?.path ?? "/product",
    meta: indexS2VT6iy50GMeta || {},
    alias: indexS2VT6iy50GMeta?.alias || [],
    redirect: indexS2VT6iy50GMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/product/index.vue").then(m => m.default || m)
  },
  {
    name: indexCiIBHqqGjzMeta?.name ?? "profile",
    path: indexCiIBHqqGjzMeta?.path ?? "/profile",
    meta: indexCiIBHqqGjzMeta || {},
    alias: indexCiIBHqqGjzMeta?.alias || [],
    redirect: indexCiIBHqqGjzMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/profile/index.vue").then(m => m.default || m)
  },
  {
    name: purchasesB8JeKMyEM4Meta?.name ?? "profile-purchases",
    path: purchasesB8JeKMyEM4Meta?.path ?? "/profile/purchases",
    meta: purchasesB8JeKMyEM4Meta || {},
    alias: purchasesB8JeKMyEM4Meta?.alias || [],
    redirect: purchasesB8JeKMyEM4Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/profile/purchases.vue").then(m => m.default || m)
  },
  {
    name: redemptionsjor0whaZuhMeta?.name ?? "profile-redemptions",
    path: redemptionsjor0whaZuhMeta?.path ?? "/profile/redemptions",
    meta: redemptionsjor0whaZuhMeta || {},
    alias: redemptionsjor0whaZuhMeta?.alias || [],
    redirect: redemptionsjor0whaZuhMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/profile/redemptions.vue").then(m => m.default || m)
  },
  {
    name: _91quiz_id_93atPSbOHxTcMeta?.name ?? "quiz-quiz_id",
    path: _91quiz_id_93atPSbOHxTcMeta?.path ?? "/quiz/:quiz_id()",
    meta: _91quiz_id_93atPSbOHxTcMeta || {},
    alias: _91quiz_id_93atPSbOHxTcMeta?.alias || [],
    redirect: _91quiz_id_93atPSbOHxTcMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/quiz/[quiz_id].vue").then(m => m.default || m)
  },
  {
    name: _91token_9374AFZRgegRMeta?.name ?? "reset-password-uid-token",
    path: _91token_9374AFZRgegRMeta?.path ?? "/reset-password/:uid()/:token()",
    meta: _91token_9374AFZRgegRMeta || {},
    alias: _91token_9374AFZRgegRMeta?.alias || [],
    redirect: _91token_9374AFZRgegRMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/reset-password/[uid]/[token].vue").then(m => m.default || m)
  },
  {
    name: resetwKvTAkeYdMMeta?.name ?? "reset",
    path: resetwKvTAkeYdMMeta?.path ?? "/reset",
    meta: resetwKvTAkeYdMMeta || {},
    alias: resetwKvTAkeYdMMeta?.alias || [],
    redirect: resetwKvTAkeYdMMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/reset.vue").then(m => m.default || m)
  },
  {
    name: shoppc6rfpmaGQMeta?.name ?? "shop",
    path: shoppc6rfpmaGQMeta?.path ?? "/shop",
    meta: shoppc6rfpmaGQMeta || {},
    alias: shoppc6rfpmaGQMeta?.alias || [],
    redirect: shoppc6rfpmaGQMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/shop.vue").then(m => m.default || m)
  },
  {
    name: signupYCBANXFaaoMeta?.name ?? "signup",
    path: signupYCBANXFaaoMeta?.path ?? "/signup",
    meta: signupYCBANXFaaoMeta || {},
    alias: signupYCBANXFaaoMeta?.alias || [],
    redirect: signupYCBANXFaaoMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/signup.vue").then(m => m.default || m)
  },
  {
    name: liveKglRQ9npWvMeta?.name ?? "streaming-event_id-live",
    path: liveKglRQ9npWvMeta?.path ?? "/streaming/:event_id()/live",
    meta: liveKglRQ9npWvMeta || {},
    alias: liveKglRQ9npWvMeta?.alias || [],
    redirect: liveKglRQ9npWvMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/streaming/[event_id]/live.vue").then(m => m.default || m)
  },
  {
    name: tipspsVh9hWTq8Meta?.name ?? "tips",
    path: tipspsVh9hWTq8Meta?.path ?? "/tips",
    meta: tipspsVh9hWTq8Meta || {},
    alias: tipspsVh9hWTq8Meta?.alias || [],
    redirect: tipspsVh9hWTq8Meta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/tips.vue").then(m => m.default || m)
  },
  {
    name: _91uuid_93HFtK4Y68IlMeta?.name ?? "waiver-uuid",
    path: _91uuid_93HFtK4Y68IlMeta?.path ?? "/waiver/:uuid()",
    meta: _91uuid_93HFtK4Y68IlMeta || {},
    alias: _91uuid_93HFtK4Y68IlMeta?.alias || [],
    redirect: _91uuid_93HFtK4Y68IlMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/waiver/[uuid].vue").then(m => m.default || m)
  },
  {
    name: compactqKJeTKgjcJMeta?.name ?? "widgets-calendars-compact",
    path: compactqKJeTKgjcJMeta?.path ?? "/widgets/calendars/compact",
    meta: compactqKJeTKgjcJMeta || {},
    alias: compactqKJeTKgjcJMeta?.alias || [],
    redirect: compactqKJeTKgjcJMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/widgets/calendars/compact.vue").then(m => m.default || m)
  },
  {
    name: fullWUcRRdDI0QMeta?.name ?? "widgets-calendars-full",
    path: fullWUcRRdDI0QMeta?.path ?? "/widgets/calendars/full",
    meta: fullWUcRRdDI0QMeta || {},
    alias: fullWUcRRdDI0QMeta?.alias || [],
    redirect: fullWUcRRdDI0QMeta?.redirect,
    component: () => import("/tmp/build_ea8f28b6/pages/[studio_url]/widgets/calendars/full.vue").then(m => m.default || m)
  }
]